import 'stylesheets/base.scss';

import React, {Component, PropTypes}  from 'react';
import {connect}                      from 'react-redux';
import {intlShape, injectIntl}          from 'react-intl';

import PureRenderComponent                      from 'app/lib/PureRenderComponent';
import {NavigationContainer}                  from './Navigation';
import Footer                                   from '../components/Footer';
import ProgressBar                              from '../components/ProgressBar';
import FlashMessage                             from '../components/FlashMessage/FlashMessage';
import {settings}                             from 'app/globals';
import {setPreferredLanguage}                 from 'modules/profile/actions';
import {isRequestingData, getFlashMessage}    from 'modules/app/selectors';
import {getLocale}                            from 'modules/profile/selectors';
import {isAuthenticated, getJWT}                      from 'modules/auth/selectors';

class App extends PureRenderComponent {

    static propTypes = {
        children: PropTypes.element,
        isAuthenticated: PropTypes.bool,
        locale: PropTypes.oneOf(settings.supportedLocales),
        isRequesting: PropTypes.bool,
        flashMessage: PropTypes.object,
        intl: intlShape.isRequired,
        token: PropTypes.string
    };

    static childContextTypes = {
        token: PropTypes.string
    };

    getChildContext = () => {
        return {
            token: this.props.token
        };
    };

    localeChangedHandler = (e) => {
        this.props.setPreferredLanguage(e.target.value);
    };

    render() {
        let {isAuthenticated, locale, children, isRequesting, flashMessage, intl:{formatMessage}, ...props} = this.props;

        if (!isAuthenticated) {
            return (
                <div>
                    {flashMessage && flashMessage.size > 0 &&
                    <FlashMessage messages={flashMessage} formatMessage={formatMessage}/>}
                    {isRequesting && <div className="app-loader"><ProgressBar /></div>}
                    {children}
                    <Footer currentLocale={locale} onLocaleChange={this.localeChangedHandler}/>
                </div>
            );
        } else {
            return (
                <div>
                    {flashMessage && flashMessage.size > 0 &&
                    <FlashMessage messages={flashMessage} formatMessage={formatMessage}/>}
                    {isRequesting && <div className="app-loader"><ProgressBar /></div>}
                    <NavigationContainer intl={this.props.intl} />
                    <main>{children}</main>
                    <Footer currentLocale={locale} onLocaleChange={this.localeChangedHandler}/>
                </div>
            );
        }


    }

}

function mapStateToProps(state) {
    return {
        isAuthenticated: isAuthenticated(state),
        locale: getLocale(state),
        isRequesting: isRequestingData(state),
        flashMessage: getFlashMessage(state),
        token: getJWT(state)
    };
}

export const AppContainer = connect(mapStateToProps, {setPreferredLanguage})(injectIntl(App));

export default App;
